<template>
  <div class="page-purchase-records">
    <div class="time-box">
      <div class="time-range-pick-container">
        <div @click="openPickDate(0)">{{form.purchaseStartTime | formatDate}}</div>
        <div class="line"></div>
        <div @click="openPickDate(1)">{{form.purchaseEndTime | formatDate}}</div>

      </div>
    </div>
    <pi-tabs type="border" :list="tabsList" :active="tabs" @change="tabsClick"></pi-tabs>
    <van-list v-model="loading"
              :finished="finished"
              :finished-text="finishedText"
              @load="onLoad"
              :immediate-check="false"
              class="list-container"
              ref="vanList">
      <div class="purchase-list">
        <div class="purchase-item" v-for="item in list" :key="item.orderNo" @click="itemClick(item)">
          <div class="item-flex">
            <div class="order-no">订单号：{{item.orderNo}}</div>
            <div class="order-time">
              <span class="order-inline">{{item.transactionTime}}</span>
              <span class="order-inline">{{item.vipName}}{{getVipDays(item)}}</span>
            </div>
          </div>
          <div class="v-center money">
            <template v-if="item.purchaseWay == 1">¥{{item.transactionAmount}}</template>
            <template v-else-if="item.purchaseWay == 2">{{item.transactionPoints}}积分</template>
            <!-- <template v-else-if="item.purchaseWay == 3">平台调整</template> -->
             <i class="right-arrow"></i>
          </div>
        </div>
      </div>
      <!-- <div class="list-tips" v-if="list.length > 0">仅展示最近1年购买记录</div> -->
    </van-list>
    
    <!--日期选择框-->
    <van-popup v-model="showTimePicker"
               position="bottom">
      <van-datetime-picker v-model="dateTimePickDate"
                           :title="pickerTitle"
                           type="date"
                           :style="{ height: '50%' }"
                           :min-date="minDate"
                           v-on:confirm="onTimePickClick(true)"
                           v-on:cancel="onTimePickClick" />
    </van-popup>
    
  </div>
</template>
<script>
import { Tab, Tabs, List, Icon, Popup, DatetimePicker } from "vant";
import {getUserVipPurchaseList} from "../../common/api";
import { formatDate } from "../../common/old/public/filters";
import tabs from '@/components/pi-tabs/pi-tabs.vue'
export default {
  name: "my-order2",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [tabs.name]: tabs,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      finishedText: '您没有更多记录了哦',
      showTimePicker: false,
      
      minDate: new Date(2020, 0),
      dateTimePickDate: null,
      chooseDateType: 0, // 0开始， 1结束
      pickerTitle: "",
      form: {
        globalPageIndex: 1,
        globalPageSize: 20,
        purchaseStartTime: this.$common.yearFristDate(),
        purchaseEndTime: new Date(),
        efficacyType: "0",
      },
      tabsList: [
        { name: "购买记录", value: "0" },
        { name: "待生效", value: "2" },
        { name: "已过期", value: "1" },
      ],
      tabs: "0",
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    itemClick(item){
      this.$common.save('purchase-records-details',item);
      this.$router.push('/purchase-records-details');
    },
    
    onLoad() {
      if (
        !this.finished &&
        !this.loading
      ) {
        this.getList();
      }
    },
    getList(){
      this.loading = true;
      let json = JSON.parse(JSON.stringify(this.form));
      json.purchaseStartTime = formatDate(this.form.purchaseStartTime);
      json.purchaseEndTime = formatDate(this.form.purchaseEndTime);
      getUserVipPurchaseList(json).then((data) => {
        if (!(data.status === this.$config.ajaxStatus)) {
          throw new Error();
        }
        this.loading = false;


        if (data.data) {
          this.list = this.list.concat(data.data);
          // 数据全部加载完成
          this.finished = this.list.length <= data.total;
        }
        if(this.list.length > 0){
          this.finishedText = '暂无更多';
        }
        this.form.globalPageIndex++;
      }).catch(error => {
        console.log('request  error:' + error);
        this.loading = false;
        this.finished = true;
      });
    },
    openPickDate(type) {
      this.showTimePicker = true;
      this.chooseDateType = type;
      let data = this.form;
      if (this.chooseDateType === 0) {
        this.pickerTitle = "请选择筛选开始时间";
        this.dateTimePickDate = new Date(
          data.purchaseStartTime.getFullYear(),
          data.purchaseStartTime.getMonth(),
          data.purchaseStartTime.getDate()
        );
      } else {
        this.pickerTitle = "请选择筛选结束时间";
        this.dateTimePickDate = new Date(
          data.purchaseEndTime.getFullYear(),
          data.purchaseEndTime.getMonth(),
          data.purchaseEndTime.getDate()
        );
      }
    },
    onTimePickClick() {
      this.showTimePicker = false;
      let startDate;
      let endDate;
      if (this.chooseDateType === 0) {
        startDate = this.dateTimePickDate;
        endDate = this.form.purchaseEndTime;
      } else {
        endDate = this.dateTimePickDate;
        startDate = this.form.purchaseStartTime;
      }
      if (Date.parse(startDate) > Date.parse(endDate)) {
        this.$toast("开始时间不能大于结束时间");
        return;
      }
        this.form.globalPageIndex = 1;
        this.list = [];
        this.finished = false;
        this.form.purchaseStartTime = startDate;
        this.form.purchaseEndTime = endDate;
        this.getList();
        // this.scrollTop = 0;
    },
    tabsClick(item) {
      this.form.efficacyType = item.value;
      this.form.globalPageIndex = 1;
      this.finished = false;
      this.list = [];
      this.tabs = item.value;

      this.getList();
    },
    getVipDays(item){
      
      if(item.vipBeginTime && item.vipEndTime){
        let start = new Date(item.vipBeginTime).getTime()/ 1000;
        let end = new Date(item.vipEndTime).getTime()/ 1000;
        let x = end - start;
        let day = 60 * 60 * 24;
        let totalDay = Math.ceil( x / day);
        if(totalDay < item.vipDays){
          return totalDay + '天'
        }else{
          return item.vipDaysDesc
        }
      }else{
        return item.vipDaysDesc
      }
    }
  }
};
</script>

<style lang="less">
.page-purchase-records {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #F5F4F9;
  .time-box {
    position: relative;
    .time-right-screen {
      position: absolute;
      right: 0;
      top: 0.4rem;
      padding-right: 0.2rem;
      color: #999999;
      font-size: 0.24rem;
      line-height: 0.33rem;
      display: flex;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
  }
  .time-range-pick-container {
    display: flex;
    align-items: center;
    font-size: 0.34rem;
    color: #333333;
    background: #f8f4f5;
    box-sizing: border-box;
    margin: 0.24rem 1rem 0.06rem 1rem;
    line-height: 0.68rem;
    justify-content: center;

    .line {
      width: 0.2rem;
      height: 0.03rem;
      margin: 0 0.3rem;
      background: rgb(156, 153, 154);
    }
  }
  .list-container {
    flex: 1;
    overflow-y: auto;
  }
  .purchase-list{
    padding: 0.2rem;
    .purchase-item{
      background-color: #fff;
      border-radius: 0.12rem;
      padding: 0.2rem;
      display: flex;
      margin-top: 0.2rem;
      .item-flex{
        flex: 1;
        font-size:0.24rem ;
        line-height: 0.33rem;
        color: #999;
        .order-time{
          margin-top: 0.2rem;
         .order-inline{
           margin-right: 0.4rem;
         } 
        }
      }
      .money{
        color: #F67731;
        font-size: 0.36rem;
        line-height: 0.5rem;
      }
    }
    .purchase-item:first-child{
      margin-top: 0;
    }
  }
  .list-tips{
    margin-top: 0.2rem;
    text-align: center;
    color: #999;
    font-size: 0.28rem;
    line-height: 0.4rem;
  }
}



</style>
